export function calcularPrecoFilial(configData = {}, plano = '') {
  const precoAtual = Number(configData.preco_filial || 29.90);
  const precoDiamante = Number(configData.preco_filial_diamante);

  if (String(plano).trim().toLowerCase() === 'diamante' && Number.isFinite(precoDiamante) && precoDiamante > 0) {
    return precoDiamante;
  }

  return precoAtual;
}
